import React, { useContext } from "react";
import AuthContext from "./AuthContext";
import { Route, useLocation, Navigate, } from "react-router-dom";
import { NoAccess } from "../GlobalComponents";
import { featureFlags } from "../config";

const PrivateRoute = ({
  children,
  requiredPermissions,
  featureFlag,
}: {
  children: any;
  requiredPermissions?: string | undefined;
  featureFlag?: boolean | undefined;
}): React.ReactElement => {
  const { isAuthenticated, setOldPath, isDevAccount, permissions } =
    useContext(AuthContext);
  const history = useLocation();
  console.log("required permissions", requiredPermissions);
  console.log("permissions", permissions);

  if(featureFlag === false) {
    return (
    <div>
      This Feature is currently disabled
    </div>)
  }

  if (isAuthenticated) {
    console.log("private route returning children");
    if (requiredPermissions) {
      const hasAccess = permissions?.includes(requiredPermissions);
      console.log("has access", hasAccess);
      if (hasAccess) {
        return children;
      } else {
        return <NoAccess />;
      }
    } else {
      return children;
    }
  } else {
    console.log("private route detecting unauthenticated", isAuthenticated);
    setOldPath(history.pathname);
    return <Navigate to="/login" />;
  }
};

export default PrivateRoute;
